import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';

import Swal from "sweetalert2";

import FilesCustom, { ExtUpload } from 'components/FilesCustom';


import {
    Button, Input, InputGroup,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import * as commonFunc from 'scripts/common';

var modalRoot;

const CImageSelector = React.forwardRef((props, ref) => {
    const [files, setFiles] = React.useState(props.files || []);
    const [path, setPath] = React.useState(props.currentPath || "");

    React.useEffect(() => {


        return () => {
            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
        }
    }, []);

    React.useEffect(() => {
        setFiles(props.files);
    }, [props.files]);

    React.useEffect(() => {
        setPath(props.currentPath);
    }, [props.currentPath]);


    function showFilesSelector() {
        var context = this;

        var title = "Sélection ressource";

        if (modalRoot) {
            modalRoot.unmount();
            modalRoot = null;
        }

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (data) {
            return new Promise((resolve, reject) => {
                if (data) {
                    if (props.onChange) props.onChange(data);
                    else setPath(data.name);

                    modalRoot.unmount();
                    resolve(data);
                }
                else {
                    modalRoot.unmount();
                    resolve();
                }
            });
        };

        /*filesFunc.convertFiles(globalProps.files, bindID, fileTypeID, { srcElem: src, className: globalProps.className, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu, renderingBadge: globalProps.badgeRendering, removeFile: removeFileProc, clickCallback: globalProps.clickCallback })
            .then((result) => {
                if (result) {
                    setFiles(result.files);
                    setTotLength(result.length);
                    setTotFiles(result.nbFiles);
                }
            });*/


        modalRoot = createRoot(document.createElement('div'));
        modalRoot.render(<FilesSelectorModal parentProps={props} title={title} srcFiles={files} withSystemFiles={props.withSystemFiles} callback={callbackModal}></FilesSelectorModal>);
    }


    return <InputGroup className="mb-2" ref={ref}>
        <Button className={`m-0 ${props.className}`} style={{ width: props.width, height: props.height, ...props.style }} color="primary" onClick={(e) => { showFilesSelector(); }}>Sélection</Button>
        <Input type="text" className="" value={path} disabled={true} readOnly={true} />
    </InputGroup>;
});

export default CImageSelector;


function FilesSelectorModal({ title, parentProps, noScroll, srcFiles, withSystemFiles, callback }) {
    React.useEffect(() => {
        if (withSystemFiles) {
            var systemFiles = [];

            const requireContext = require.context('assets/img/res', false, /\.(png|jpe?g|svg)$/);
            const sysFiles = requireContext.keys().map(requireContext);
            sysFiles.forEach((filePath) => {
                var splitS = filePath.split("\/");
                var fileModName = splitS[splitS.length - 1].split("\.");

                var sysFile = { instanceFile: {} };
                sysFile.name = fileModName[0] + "." + fileModName[fileModName.length - 1];
                sysFile.instanceFile.preview = require("assets/img/res/" + sysFile.name);

                sysFile.categ = "SYS";
                var tempID = parseInt(Math.floor(Date.now() + Math.random() * 10000000000000001).toString().substr(6));
                sysFile.idFile = tempID;
                sysFile.length = 0;
                sysFile.prefix = "";
                sysFile.isSystem = true;

                systemFiles.push(sysFile);
            });

            setFiles([...srcFiles, ...systemFiles]);
        }
        else {
            setFiles(srcFiles);
        }
    }, []);

    const [files, setFiles] = React.useState(null);
    const [selectedFile, setSelectedFile] = React.useState(null);

    var elemID =  0;// /!\ est affecté aux images

    return (
        <Modal isOpen={true} className={`modal-report ${noScroll ? "modal-noscroll" : ""}`} size="xl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <FilesCustom className="reportDlg-files" title="" bindID={elemID} checkRights={() => false} src={null} defaultFilterType={"img"} smallBox={true}
                    files={files} setFiles={(compFiles) => { }} noUploads={true} noContextMenu={true} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={"PJ"}
                    onFileClick={(dataFile, fileNode) => { setSelectedFile(dataFile); }} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="success" onClick={() => {
                    callback(selectedFile || { name: "NONE" });
                }}><i className="fa fa-plus"></i>Sélectionner</Button>
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>Annuler</Button>
            </ModalFooter>
        </Modal>
    );
}